import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import app from "@/store/app";
import auth from "@/store/auth";
import form from "@/store/form";
import page from "@/store/page";
import loader from "@/store/loader";
import profile from "@/store/profile";
import knowledge from "@/store/knowledge";
import permissions from "@/store/permissions";
import organisation from "@/store/organisation";

export default new Vuex.Store({
    modules: {
        app,
        auth,
        form,
        page,
        loader,
        profile,
        knowledge,
        permissions,
        organisation
    }
});
